import { config } from '@/config/config';
import { env } from '@/env';
import { ExtensionInstallationDialog } from '@/modules/extension/components';
import { extensionStoreUrl } from '@/modules/extension/constants';
import { ReviewPrizepoolModal } from '@/modules/review-prizepool';
import { SubscriptionUpgradeModal, TrialModal } from '@/modules/saas-upgrade';
import { UserFeedbackPrompt } from '@/modules/user-feedback';

export const AuthorizedAppModals = () => (
    <>
        {extensionStoreUrl && !env.VITE_DEMO && !env.VITE_PLAYWRIGHT_RUN && (
            <ExtensionInstallationDialog extensionStoreUrl={extensionStoreUrl} />
        )}

        {!config.demo.enable && (
            <>
                <UserFeedbackPrompt />
                <ReviewPrizepoolModal />
                <TrialModal />
            </>
        )}
        <SubscriptionUpgradeModal />
    </>
);
